import { cB as e, cM as a, cE as r, c as o, cNotM as t } from "./ghl-ui.es384.js";
import { fadeInHeightExpandTransition as i } from "./ghl-ui.es1315.js";
const s = e("collapse", "width: 100%;", [e("collapse-item", `
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 margin: var(--n-item-margin);
 `, [a("disabled", [r("header", "cursor: not-allowed;", [r("header-main", `
 color: var(--n-title-text-color-disabled);
 `), e("collapse-item-arrow", `
 color: var(--n-arrow-color-disabled);
 `)])]), e("collapse-item", "margin-left: 32px;"), o("&:first-child", "margin-top: 0;"), o("&:first-child >", [r("header", "padding-top: 0;")]), a("left-arrow-placement", [r("header", [e("collapse-item-arrow", "margin-right: 4px;")])]), a("right-arrow-placement", [r("header", [e("collapse-item-arrow", "margin-left: 4px;")])]), r("content-wrapper", [r("content-inner", "padding-top: 16px;"), i({
  duration: "0.15s"
})]), a("active", [r("header", [a("active", [e("collapse-item-arrow", "transform: rotate(90deg);")])])]), o("&:not(:first-child)", "border-top: 1px solid var(--n-divider-color);"), t("disabled", [a("trigger-area-main", [r("header", [r("header-main", "cursor: pointer;"), e("collapse-item-arrow", "cursor: default;")])]), a("trigger-area-arrow", [r("header", [e("collapse-item-arrow", "cursor: pointer;")])]), a("trigger-area-extra", [r("header", [r("header-extra", "cursor: pointer;")])])]), r("header", `
 font-size: var(--n-title-font-size);
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 transition: color .3s var(--n-bezier);
 position: relative;
 padding: var(--n-title-padding);
 color: var(--n-title-text-color);
 `, [r("header-main", `
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 color: var(--n-title-text-color);
 `), r("header-extra", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), e("collapse-item-arrow", `
 display: flex;
 transition:
 transform .15s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: 18px;
 color: var(--n-arrow-color);
 `)])])]);
export {
  s as default
};
